import { Paper, styled } from '@mui/material';
import { afcsBlue } from '../../theme/AFCS';

export const SectionPaper = styled(Paper)({
  backgroundColor: 'white',
  color: afcsBlue,
  padding: '4px 15px',
  margin: '10px 0'
});